module.exports = __webpack_public_path__ + "static/media/FiraSans-MediumItalic.accc8278.ttf";